import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postCheckoutFlow = async (noteContent, patientID) => {
  const apiURL = API_HOST + '/checkout';
  const { token, userID } = useCurrentUser();

  // console.log('saving ');
  try {
    const { data } = await axios.post(
      apiURL,
      {
        patient_note: {
          title: '',
          content: noteContent,
          patient_id: patientID,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
          'x-dqpn-user-id': userID,
        },
      },
    );
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
